import { AxiosError } from 'axios'

export class AxiosErrorHandler {
  readonly _error: AxiosError
  readonly _errorData: any | null
  readonly _errorStatus: number | null
  readonly _errorMessage: string
  readonly _errorDetails: string[]
  private _isLogOutError: boolean = false
  private _isMFAVerificationError: boolean = false
  private _isMFATokenExpiredError: boolean = false

  constructor(error: AxiosError) {
    this._error = error
    this._errorData = error.response?.data ?? null
    this._errorStatus = error.response?.status ?? null
    this._errorMessage = this._errorData?.error?.message ?? ''
    this._errorDetails = this._errorData?.error?.details ?? []

    this.handleError()
  }

  get errorDetails() {
    return this._errorDetails
  }

  get isLogOutError() {
    return this._isLogOutError
  }

  get isMFAVerificationError() {
    return this._isMFAVerificationError
  }

  get isMFATokenExpiredError() {
    return this._isMFATokenExpiredError
  }

  private handleError() {
    if (this._errorStatus && [401, 403].includes(this._errorStatus)) {
      this._isLogOutError = true
    } else if (this._errorStatus && this._errorStatus === 400 && this._errorMessage) {
      if (this._errorMessage === 'MFA verification failed') {
        this._isMFAVerificationError = true
      } else if (this._errorMessage === 'MFA token is expired') {
        this._isMFATokenExpiredError = true
      } else {
        console.error(this._error)
      }
    } else {
      console.error(this._error)
    }
  }
}
